<template>
  <div class="messages">

    <div class="chat-block">
      
      <div class="empty" v-if="chat.length == 0">
        <div class="icon"><i class="fal fa-comment-alt"></i></div>
        <div class="text">{{ permissions.canChat ? 'Start a conversation' : 'No messages' }}</div>
      </div>

      <div class="chat-log" ref="chatLog" v-else>

        <ul class="the-messages">
          <li
            v-for="(c, index) in chat"
            :key="index"
            :class="[
              c.user_id != userId ? 'belongs-to-other' : 'belongs-to-user'
            ]"
            >
            <div class="the-user">
              {{ c.user.name }} ({{ niceRoleName(c.user.user_type) }})
            </div>
            <div class="message-inner">
              {{ c.message }}
            </div>
            <div class="the-meta" v-html="processDateTime(c.created_at)" />
          </li>
        </ul>

        <Loader v-if="isSending" />

      </div>

    </div>

    <div class="send-box" v-if="permissions.canChat && thisCase.status != 'archive'">

      <input 
        type="text" 
        class="chat-message-input" 
        placeholder="Type your message..." 
        v-model="composeMessage"
        v-on:keyup.enter="sendMessage"
        :disabled="isSending"
        />

      <div 
        class="send-button"
        :class="{
          'disabled': composeMessage == '' || isSending
        }"
        @click="sendMessage"
        >
        <i class="fal fa-paper-plane"></i>
      </div>

    </div>

  </div>
</template>

<script>

import axios from 'axios'
import Pusher from 'pusher-js'
import Loader from "@/Components/Atoms/Loader3dot"

export default {
  components: {
    Loader
  },
  props: [
    'thisCase',
    'chat',
    'userId',
    'isAdmin',
    'projectUser',
    'permissions'
  ],
  data: () => {
    return {
      composeMessage: '',
      pusher: null,
      channel: null,
      theChannel: '',
      isSending: false
    }
  },
  mounted(){
    
    this.pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
      cluster: 'eu'
    })

    this.theChannel = this.thisCase.hashid + '-' + this.thisCase.created_at.split(' ').join('').split(':').join('').split('-').join('').split('.')[0]

    this.channel = this.pusher.subscribe(this.theChannel)
    this.channel.bind('new-message', (data) => {
      console.log('received pusher', data)
      this.chat.push(data.chat)
      setTimeout(() => {
        this.isSending = false
        this.scrollToBottom()
      }, 100)
    })
    
    setTimeout(() => {
      this.scrollToBottom()
    },1000)

  },
  beforeUnmount(){
    this.pusher.unsubscribe(this.theChannel)
    delete this.pusher
    delete this.channel
  },
  methods: {
    sendMessage() {
      if(this.composeMessage != ''){

        this.channel = this.pusher.subscribe(this.theChannel) // resubscribe to channel incase connection was lost. prevents never ending loading.

        this.isSending = true
        setTimeout(() => {
          this.scrollToBottom()
        }, 100)

        let payload = {
          message: this.composeMessage,
          project_id: this.thisCase.id,
          channel: this.theChannel
        }

        // this.$inertia.post(`/chat/send-message`, payload) // send message
        axios.post(`/chat/send-message`, payload).then((res) => {
          console.log('message response', res)
        })
        this.composeMessage = '' // reset the text field

      }else{
        // console.log('no message to send')
      }
    },
    processDateTime(inputDateTime){
      
      let d = new Date(inputDateTime),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hours = d.getHours(),
        minutes = d.getMinutes();

      hours = ("0" + hours).slice(-2)
      minutes = ("0" + minutes).slice(-2)
      day = ("0" + day).slice(-2)
      month = ("0" + month).slice(-2)

      return `<strong>${hours}:${minutes}</strong> ${day}/${month}/${year}`
    },
    scrollToBottom(){
      setTimeout(() => {
        try {
          if(this.chat.length > 0){
            let chatLog = this.$refs.chatLog
            chatLog.scrollTop = chatLog.scrollHeight
          }
        }catch{
          // console.log('error scrolling to bottom')
        }
      }, 300)
    },
    niceRoleName(type){
			switch(type){
				case 'admin':
					return 'Meshworks Admin'
					break
				case 'global_viewer':
					return 'Meshworks Viewer'
					break
				case 'team_admin':
					return 'Distributor Admin'
					break
				case 'team_user':
					return 'Distributor User'
					break
				case 'viewer':
					return 'Viewer'
					break
				case 'user':
					return 'User'
					break
			}
		},
  },
  computed: {
    
  }
}

</script>

<style scoped lang="sass">

$chatBoxHeight: 450px

.messages
  width: 100%
  height: auto
  border-radius: 8px
  margin-bottom: 30px
  box-shadow: 0 1px 3px rgba(#000, 0.2)
  background-color: #fff
  overflow: hidden
  position: relative

  .chat-block
    height: $chatBoxHeight
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    
    .empty
      display: flex
      flex-direction: column
      align-items: center
      padding: 30px

      .icon
        color: rgba(#000,0.4)
        font-size: 60px
        margin-bottom: 10px

      .text
        font-family: 'Roboto', sans-serif
        font-size: 18px
        color: #666

    .chat-log
      height: $chatBoxHeight
      width: 100%
      overflow-y: auto
      overflow-x: hidden
      scrollbar-width: none

      &::-webkit-scrollbar
        display: none

      .the-messages
        min-height: $chatBoxHeight
        height: auto
        list-style-type: none
        padding: 20px 20px 0px
        margin: 0
        width: 100%
        display: flex
        flex-direction: column
        justify-content: flex-end

        li
          margin: 0 0 10px
          width: auto
          max-width: 320px
          display: flex
          flex-direction: column
          
          .message-inner
            padding: 10px 15px
            width: 100%
            font-size: 16px
            font-family: 'Roboto', sans-serif
            line-height: 1.2

          .the-user
            font-size: 12px
            color: #252525
            font-weight: 700
            padding: 0 15px 3px

          .the-meta
            font-size: 10px
            color: #252525
            font-weight: 400
            padding: 3px 15px 0px

          &.belongs-to-user
            align-self: flex-end
            align-items: flex-end
            
            .message-inner
              background-color: #75BBFF
              border-radius: 10px 0 10px 10px
              color: #fff
              font-weight: 700

          &.belongs-to-other
            align-self: flex-start
            align-items: flex-start

            .message-inner
              background-color: #ededed
              border-radius: 0 10px 10px 10px
              color: #252525

  .send-box
    width: 100%
    border-top: 1px solid rgba(#000, 0.1)
    display: grid
    grid-template-columns: 1fr 50px
    grid-column-gap: 10px
    align-items: center
    padding: 16px 20px

    input[type="text"]
      width: 100%
      background-color: #eee
      height: 50px
      border-radius: 25px
      overflow: hidden
      padding: 0 25px
      border: none

    .send-button
      height: 50px
      width: 50px
      background-color: #75BBFF
      border-radius: 50%
      overflow: hidden
      display: flex
      align-items: center
      justify-content: center
      cursor: pointer
      transition: all 300ms

      .fal
        color: #fff
        font-size: 22px

      &:hover
        background-color: darken(#75BBFF, 7%)

      &.disabled
        cursor: not-allowed
        opacity: 0.6

</style>